module.exports = __webpack_public_path__ + "img/donation.6a7be74d.jpg";